import { render } from "./AppSwitcherDropdown.vue?vue&type=template&id=3e5e9c69&scoped=true"
import script from "./AppSwitcherDropdown.vue?vue&type=script&lang=js"
export * from "./AppSwitcherDropdown.vue?vue&type=script&lang=js"

import "./AppSwitcherDropdown.vue?vue&type=style&index=0&id=3e5e9c69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5e9c69"]])

export default __exports__